export default {
  props: {
    history: Array,
  },
};
